var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
var defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
};
function slot(name) {
    if (name === void 0) { name = ""; }
    return { ref: function (e) { return (e ? e.setAttribute("slot", name) : null); } };
}
export var SlottedSVG = function (_a) {
    var path = _a.path, slotName = _a.slot, children = _a.children, props = __rest(_a, ["path", "slot", "children"]);
    return (React.createElement("svg", __assign({}, slot(slotName), props, defaultProps),
        !!path && React.createElement("path", { d: path }),
        children));
};
